<template>
  <div>
    <v-dialog v-model="createLocationDialog" scrollable max-width="500px">
      <v-form ref="formLocation">
        <v-card>
          <v-card-title>Add location</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-text-field
              v-model="location.addressLine1"
              label="Address line 1"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model="location.addressLine2"
              label="Address line 2"
              required
            ></v-text-field>
            <v-text-field
              v-model="location.town"
              label="Town/City"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model="location.postcode"
              label="Postcode"
              required
              :rules="[rules.required]"
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="blue darken-1"
              text
              @click="createLocationDialog = false"
              class="hp--btn"
              >Close</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              @click="createLocation"
              text
              class="hp--btn"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="updateLocationDialog" scrollable max-width="500px">
      <v-form ref="formUpdateLocation">
        <v-card>
          <v-card-title>Edit location</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-text-field
              v-model="location.addressLine1"
              label="Address line 1"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model="location.addressLine2"
              label="Address line 2"
              required
            ></v-text-field>
            <v-text-field
              v-model="location.town"
              label="Town/City"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model="location.postcode"
              label="Postcode"
              required
              :rules="[rules.required]"
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="blue darken-1"
              text
              @click="updateLocationDialog = false"
              class="hp--btn"
              >Close</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              @click="updateLocation"
              text
              class="hp--btn"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-card class="mx-auto">
      <v-toolbar flat>
        <v-toolbar-title class="grey--text">Locations</v-toolbar-title>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              dark
              small
              absolute
              bottom
              left
              fab
              v-on="on"
              @click="
                location = [];
                createLocationDialog = !createLocationDialog;
              "
              class="hp--btn"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>New location</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            color="info"
            dark
            small
            absolute
            top
            right
            fab
            v-on="on"
            @click="sendMessageToParent"
            class="mr-2 mt-8 hp--btn"
          >
            <v-icon>keyboard_return</v-icon>
          </v-btn>
        </template>
        <span>View companies</span>
      </v-tooltip>

      <v-card-title style="padding-top: 0; padding-bottom: 0">
        <v-spacer></v-spacer>
        <v-text-field
          v-model="eventSearch"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :items="locations"
          :headers="locationHeaders"
          class="elevation-1"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :search="eventSearch"
          :sort-by="['address1, address2']"
        >
          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="success" @click="editLocation(item)"
                  >edit</v-icon
                >
              </template>
              <span>Update location</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" @click="deleteLocation(item)" color="error"
                  >delete</v-icon
                >
              </template>
              <span>Delete location</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "./../graphql/queries";
import * as mutations from "./../graphql/mutations";
export default {
  props: {
    company: Object,
  },
  data() {
    return {
      location: [],
      locations: {},
      createLocationDialog: false,
      updateLocationDialog: false,
      eventSearch: "",
      locationHeaders: [
        {
          text: "Address 1",
          align: "left",
          value: "addressLine1",
        },
        { text: "Address2", value: "addressLine2" },
        { text: "Town", value: "town" },
        { text: "Postcode", value: "postcode" },
        { value: "action", align: "right", sortable: false },
      ],
      page: 0,
      itemsPerPage: -1,
      rules: {
        required: (v) => !!v || "This field is required.",
        email: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      },
    };
  },
  created() {
    const that = this;
    that.locations = [];
    const lookup = `query GetEventCompany($id: ID!) {
              getEventCompany(id: $id) {
                eventLocationLookup(filter: {isDeleted: {eq: 0}}) {
                  items {
                    id
                    postcode
                    town
                    addressLine1
                    addressLine2
                    createdAt
                    isDeleted
                  }
                }
              }
            }`;
    // Update event
    API.graphql(
      graphqlOperation(lookup, {
        id: that.company.id,
      })
    ).then((result) => {
      const locations = result.data.getEventCompany.eventLocationLookup.items;
      locations.forEach(function (location) {
        that.locations.push({
          id: location.id,
          addressLine1: location.addressLine1,
          addressLine2: location.addressLine2,
          town: location.town,
          postcode: location.postcode,
        });
      });
      that.locations = _.orderBy(that.locations, "addressLine1", "asc");
    });
  },
  methods: {
    sendMessageToParent() {
      this.$emit("switchEventPanel", "companies");
    },
    async createLocation() {
      if (this.$refs.formLocation.validate()) {
        API.graphql(
          graphqlOperation(mutations.createEventLocationLookup, {
            input: {
              addressLine1: this.location.addressLine1,
              addressLine2: this.location.addressLine2,
              town: this.location.town,
              postcode: this.location.postcode,
              createdAt: new Date().toISOString(),
              eventLocationLookupEventCompanyId: this.company.id,
              isDeleted: 0,
            },
          })
        ).then((result) => {
          this.locations.push({
            id: result.data.createEventLocationLookup.id,
            addressLine1: result.data.createEventLocationLookup.addressLine1,
            addressLine2: result.data.createEventLocationLookup.addressLine2,
            town: result.data.createEventLocationLookup.town,
            postcode: result.data.createEventLocationLookup.postcode,
            isDeleted: result.data.createEventLocationLookup.isDeleted,
          });
          this.locations = _.orderBy(this.locations, "addressLine1", "asc");
          this.createLocationDialog = false;
        });
      }
    },
    editLocation(location) {
      if (location.id) {
        API.graphql(
          graphqlOperation(queries.getEventLocationLookup, {
            id: location.id,
          })
        ).then((result) => {
          const eventLocation = result.data.getEventLocationLookup;
          this.location.id = eventLocation.id;
          this.location.addressLine1 = eventLocation.addressLine1;
          this.location.addressLine2 = eventLocation.addressLine2;
          this.location.town = eventLocation.town;
          this.location.postcode = eventLocation.postcode;
          this.updateLocationDialog = true;
        });
      }
    },
    async updateLocation() {
      const that = this;
      if (this.$refs.formUpdateLocation.validate()) {
        API.graphql(
          graphqlOperation(mutations.updateEventLocationLookup, {
            input: {
              id: this.location.id,
              addressLine1: this.location.addressLine1,
              addressLine2: this.location.addressLine2,
              town: this.location.town,
              postcode: this.location.postcode,
              isDeleted: 0,
            },
          })
        ).then((result) => {
          const location = result.data.updateEventLocationLookup;
          const index = this.locations.findIndex(
            (loc) => loc.id === location.id
          );
          Object.assign(that.locations[index], location);
          this.updateLocationDialog = false;
        });
      }
    },
    deleteLocation(location) {
      if (location.id) {
        API.graphql(
          graphqlOperation(mutations.updateEventLocationLookup, {
            input: {
              id: location.id,
              isDeleted: 1,
            },
          })
        ).then((result) => {
          this.locations = this.locations.filter(
            (location) =>
              location.id !== result.data.updateEventLocationLookup.id
          );
        });
      }
    },
  },
};
</script>